import React from 'react';

import { Grid } from '@mui/material';

import { DateFormatPatterns } from '@clearverify/constants';
import { Nullable } from '@clearverify/types';
import { formatDate, formatPhoneNumber } from '@clearverify/utils';

import { PeoStaffInfoFragment } from 'src/api';
import { DetailGridItem } from 'src/components/common';

interface PeoStaffViewDetailsModalHeadProps {
  peoStaff: PeoStaffInfoFragment;
  peoStaffRoleName: Nullable<string>;
  showStatus?: boolean;
  showRole?: boolean;
}

export const PeoStaffViewDetailsModalHead: React.FC<PeoStaffViewDetailsModalHeadProps> = ({
  peoStaff,
  peoStaffRoleName,
  showStatus = true,
  showRole = true,
}) => {
  return (
    <Grid container spacing={2}>
      <DetailGridItem topText="First Name" bottomText={peoStaff.user.firstName} />
      <DetailGridItem topText="Last Name" bottomText={peoStaff.user.lastName} />
      <DetailGridItem
        topText="Date of Birth"
        bottomText={formatDate(peoStaff.user.birthDate, DateFormatPatterns.shortDateWithSlash)}
      />
      <DetailGridItem
        topText="Phone Number"
        bottomText={formatPhoneNumber(peoStaff.user.phoneNumber)}
      />
      <DetailGridItem topText="Email Address" bottomText={peoStaff.user.email} />
      {showRole && <DetailGridItem topText="Role" bottomText={peoStaffRoleName} />}
      {showStatus && <DetailGridItem topText="Status" bottomText={peoStaff.user.status} />}
    </Grid>
  );
};
